import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  margin-bottom: 24px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  }
`;

export const KeywordItem = styled.div`
  padding: 10px 12px;
  background-color: #f5f9ff;
  border-left: 3px solid #1890ff;
  margin-bottom: 8px;
  border-radius: 4px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .keyword-key {
    font-weight: 600;
    color: #1890ff;
    font-size: 13px;
    flex: 0 0 auto;
    margin-right: 12px;
  }

  .keyword-desc {
    color: #262626;
    font-size: 13px;
    flex: 1;
  }

  .copy-btn {
    opacity: 0;
    transition: opacity 0.2s;
  }

  &:hover .copy-btn {
    opacity: 1;
  }
`;

export const InstructionBox = styled.div`
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;

  .icon {
    color: #0050b3;
    flex-shrink: 0;
    font-size: 16px;
    margin-top: 2px;
  }

  .text {
    color: #0050b3;
    font-size: 13px;
    line-height: 1.5;
    margin: 0;
  }
`;

export const FormSectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  .icon {
    color: #1890ff;
  }
`;
